"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var ApproveErc20_1 = require("./ApproveErc20");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var entities_1 = require("../entities");
/**
 * Procedure that creates a new Security Token on the Polymath ecosystem
 */


var CreateSecurityToken =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(CreateSecurityToken, _Procedure_1$Procedur);

  function CreateSecurityToken() {
    var _this;

    _classCallCheck(this, CreateSecurityToken);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CreateSecurityToken).apply(this, arguments));
    _this.type = types_1.ProcedureType.CreateSecurityToken;
    return _this;
  }
  /**
   * - Approve spending the required POLY to pay the Security Token launch fee
   * - Create the new Security Token
   *
   * Note that this procedure will fail if:
   * - The Security Token symbol hasn't been reserved
   * - The Security Token symbol has already been reserved by another issuer
   * - The Security Token already been launched
   */


  _createClass(CreateSecurityToken, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var args, context, name, symbol, _args$detailsUrl, detailsUrl, divisible, treasuryWallet, securityTokenRegistry, currentWallet, factories, wallet, _ref, _ref2, isAvailable, isRegisteredByCurrentIssuer, isLaunched, _ref3, _ref4, usdFee, polyFee, _ref5, _ref6, newToken;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                args = this.args, context = this.context;
                name = args.name, symbol = args.symbol, _args$detailsUrl = args.detailsUrl, detailsUrl = _args$detailsUrl === void 0 ? '' : _args$detailsUrl, divisible = args.divisible, treasuryWallet = args.treasuryWallet;
                securityTokenRegistry = context.contractWrappers.securityTokenRegistry, currentWallet = context.currentWallet, factories = context.factories;

                if (!treasuryWallet) {
                  _context2.next = 7;
                  break;
                }

                wallet = treasuryWallet;
                _context2.next = 10;
                break;

              case 7:
                _context2.next = 9;
                return currentWallet.address();

              case 9:
                wallet = _context2.sent;

              case 10:
                _context2.next = 12;
                return Promise.all([securityTokenRegistry.tickerAvailable({
                  ticker: symbol
                }), securityTokenRegistry.isTickerRegisteredByCurrentIssuer({
                  ticker: symbol
                }), securityTokenRegistry.isTokenLaunched({
                  ticker: symbol
                })]);

              case 12:
                _ref = _context2.sent;
                _ref2 = _slicedToArray(_ref, 3);
                isAvailable = _ref2[0];
                isRegisteredByCurrentIssuer = _ref2[1];
                isLaunched = _ref2[2];

                if (!isAvailable) {
                  _context2.next = 19;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "The security token symbol ".concat(symbol, " hasn't been reserved. You need to call \"reserveSecurityToken\" first.")
                });

              case 19:
                if (isRegisteredByCurrentIssuer) {
                  _context2.next = 21;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "The security token symbol ".concat(symbol, " has already been reserved by another issuer.")
                });

              case 21:
                if (!isLaunched) {
                  _context2.next = 23;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "The security token symbol ".concat(symbol, " has already been launched")
                });

              case 23:
                _context2.next = 25;
                return securityTokenRegistry.getFees({
                  feeType: contract_wrappers_1.FeeType.StLaunchFee
                });

              case 25:
                _ref3 = _context2.sent;
                _ref4 = _slicedToArray(_ref3, 2);
                usdFee = _ref4[0];
                polyFee = _ref4[1];
                _context2.t0 = this.addProcedure(ApproveErc20_1.ApproveErc20);
                _context2.t1 = polyFee;
                _context2.next = 33;
                return securityTokenRegistry.address();

              case 33:
                _context2.t2 = _context2.sent;
                _context2.t3 = {
                  amount: _context2.t1,
                  spender: _context2.t2
                };
                _context2.next = 37;
                return (0, _context2.t0)(_context2.t3);

              case 37:
                _context2.next = 39;
                return this.addTransaction(securityTokenRegistry.generateNewSecurityToken, {
                  tag: types_1.PolyTransactionTag.CreateSecurityToken,
                  fees: {
                    usd: usdFee,
                    poly: polyFee
                  },
                  resolvers: [function () {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee() {
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              return _context.abrupt("return", factories.securityTokenFactory.fetch(entities_1.SecurityToken.generateId({
                                symbol: symbol
                              })));

                            case 1:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));
                  }]
                })({
                  name: name,
                  ticker: symbol,
                  tokenDetails: detailsUrl,
                  divisible: divisible,
                  protocolVersion: '0',
                  treasuryWallet: wallet
                });

              case 39:
                _ref5 = _context2.sent;
                _ref6 = _slicedToArray(_ref5, 1);
                newToken = _ref6[0];
                return _context2.abrupt("return", newToken);

              case 43:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return CreateSecurityToken;
}(Procedure_1.Procedure);

exports.CreateSecurityToken = CreateSecurityToken;